import { FunctionComponent, useCallback } from 'react'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './styles'
import { Text } from '@conexasaude/conexa-hero'
import { useCallMonitoringStore } from '@/modules/VideoCall/store/call-monitoring-store'
import { useAttendanceCallStore } from '../../store/useAttendanceCall'

const CallRestartedModal: FunctionComponent<{
  hookSuccess()
}> = ({ hookSuccess }) => {
  const { closeModal } = useModalContext()
  const attendanceCall = useAttendanceCallStore(store => store.attendanceCall)
  const styles = useStyles()

  const realtimeAppointmentCall = useCallMonitoringStore(state => state.call)

  const handleSucess = useCallback(() => {
    closeModal()
    hookSuccess()
  }, [closeModal, hookSuccess])

  return (
    <Modal
      id="CALL_RESTARTED"
      primaryAction={handleSucess}
      primaryActionLabel="Voltar para chamada"
    >
      <Text css={styles.informativeText}>
        {realtimeAppointmentCall
          ? realtimeAppointmentCall?.additionalInfo?.professionalName
          : attendanceCall?.professionalName}{' '}
        está precisando entrar em contato com você.
      </Text>
    </Modal>
  )
}

export default CallRestartedModal
